<div class="my-performance-card">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._771_MY_PERFORMANCE | translate"
        [isLoading]="state.pending?.reload || _isTrendLoading"
        [hasLaunchAction]="true"
        [launchButtonTooltip]="_i18n._11179_VIEW_ALL_METRICS | translate"
        (launchAction)="_onLaunchSelect()"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [refreshButtonTooltip]="_i18n._11174_RESET_CARD | translate"
        [expandButtonTooltip]="
            _isExpanded === false
                ? (_i18n._11176_EXPAND_CARD | translate)
                : (_i18n._11175_COLLAPSE_CARD | translate)
        "
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        [hasExpandAction]="state.pending.hasData"
        (expandAction)="_onExpandClick()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-performance-card--no-data">
            <h2 class="my-performance-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>

    <ng-container *ngIf="_isExpanded === false && state.pending.hasData">
        <cmps-card-header-row-component
            *ngIf="_isExpanded === false"
            [cardHeaderLabel]="state?.headerData?.titleLabel"
            [timePeriod]="state?.headerData?.periodDate"
            [isShowingIcon]="state?.headerData?.hasHeaderIcon"
            [isHumanView]="state?.headerData?.isHumanView"
        ></cmps-card-header-row-component>
        <ng-container>
            <cmps-insight-coaching-performance
                [label]="_i18n._9945_TOTAL_PERFORMANCE | translate"
                [isTotalPerformance]="true"
                [isExpanded]="
                    _getLoggedInUserData()?.totalPerformancePillar?.isCollapsed
                "
                [expandCollapseTooltip]="
                    !_getLoggedInUserData()?.totalPerformancePillar?.isCollapsed
                        ? (_i18n._11180_EXPAND_ALL_PILLARS | translate)
                        : (_i18n._11181_COLLAPSE_ALL_PILLARS | translate)
                "
                [isParentPillar]="true"
                [hasLaunchButton]="false"
                [data]="
                    _getLoggedInUserData()?.totalPerformancePillar?.parentPillar
                        .progressBarData
                "
                (selectedValue)="_onSelectPillar($event, true)"
                (toggleExpand)="
                    _onTogglePillar(
                        _getLoggedInUserData()?.totalPerformancePillar?.id
                    )
                "
            >
            </cmps-insight-coaching-performance>
        </ng-container>

        <ng-container>
            <div
                class="cmps-insight-coaching-performance-container"
                *ngFor="
                    let pillar of _getLoggedInUserData()?.pillarsData;
                    let i = index
                "
            >
                <cmps-insight-coaching-performance
                    [label]="pillar.parentPillar.titleLabel"
                    [launchButtonTooltip]="
                        pillar.parentPillar.launchButtonTooltip
                    "
                    [isTotalPerformance]="false"
                    [isExpanded]="pillar.isCollapsed"
                    [expandCollapseTooltip]="
                        !pillar?.isCollapsed
                            ? (_i18n._11182_EXPAND_PILLAR | translate)
                            : (_i18n._11183_COLLAPSE_PILLAR | translate)
                    "
                    [hasLaunchButton]="true"
                    [data]="pillar.parentPillar.progressBarData"
                    [childPillar]="childPillars"
                    (toggleExpand)="_onTogglePillar(pillar.id)"
                    (launchAction)="_onLaunchSelect(pillar.id)"
                    (selectedValue)="_onSelectPillar($event, false)"
                >
                </cmps-insight-coaching-performance>
                <div
                    #childPillars
                    *ngIf="pillar.isCollapsed"
                >
                    <ng-container *ngFor="let cc of pillar.childPillars">
                        <cmps-metric-performance
                            *ngIf="cc.isVisible"
                            [metricData]="cc"
                            showTrend="true"
                            (toggleExpand)="
                                _onTogglePillar(pillar.id, cc.metricId)
                            "
                            (trendAction)="_trendView(cc)"
                        >
                        </cmps-metric-performance>
                        <ng-container
                            *ngIf="cc.childRows?.length && cc.isExpanded"
                        >
                            <ng-container
                                *ngFor="
                                    let childRow of cc.childRows;
                                    let last = last
                                "
                            >
                                <cmps-metric-performance
                                    [class.cmps-metric-performance--last-child]="
                                        last
                                    "
                                    *ngIf="childRow.isVisible"
                                    [metricData]="childRow"
                                    [showTrend]="true"
                                    [last-child]="last"
                                    (onUserClickAction)="
                                        _onLaunchSelect($event)
                                    "
                                    (trendAction)="_trendView(childRow)"
                                >
                                </cmps-metric-performance>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="_isExpanded === true">
        <div cmpsInsightExplorerWidget></div>
    </ng-container>
</ng-template>
